/**
 * Redirect shim — the canonical reset-password screen lives at app/(auth)/reset-password.tsx.
 * This file exists only to prevent a duplicate-route build warning while keeping
 * any legacy deep links that might target /reset-password working.
 */
import { useEffect } from 'react';
import { useRouter, useLocalSearchParams } from 'expo-router';

export default function ResetPasswordRedirect() {
  const router = useRouter();
  const params = useLocalSearchParams();

  useEffect(() => {
    // Forward all params to the canonical auth screen
    router.replace({ pathname: '/(auth)/reset-password', params } as any);
  }, []);

  return null;
}
